module.exports = __webpack_public_path__ + "img/pe.ce50d30f.png";